<template>
  <div class="setPass">
    <div class="item flex">
      <div class="name">旧密码</div>
      <el-input v-model="pass0" type="password" placeholder="点击输入密码" style="width: 300px" />
    </div>
    <div style="height: 20px"></div>
    <div class="item flex">
      <div class="name">新密码</div>
      <el-input v-model="pass1" type="password" placeholder="点击输入密码" style="width: 300px" />
    </div>
    <div style="height: 20px"></div>
    <div class="item flex">
      <div class="name">确认密码</div>
      <el-input v-model="pass2" type="password" placeholder="点击输入密码" style="width: 300px" />
    </div>
    <div style="height: 40px"></div>
    <el-button type="primary" size="large" :loading="postLoading" class="regTel" @click="handlebtn">修改密码</el-button>
    <div style="height: 60px"></div>
  </div>
</template>

<script>
import { reactive, toRefs, watch } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import { ElMessage, ElNotification  } from 'element-plus'
import { api } from '@/api'
export default {
  name: "serPass",
  setup() {
    let Router = useRouter()
    let store = useStore()
    let initData = reactive({
      pass0: '',
      pass1: '',
      pass2: '',
      postLoading: false,
      userInfo: "",
    })
    watch(() => store.state.userInfo, (newVal) => {
      if(!newVal) {
        Router.push("/")
      } 
      initData.userInfo = newVal
    }, {immediate: true})
    function handlebtn() {
      if(initData.pass1.length < 4 || initData.pass1.length > 16) {
        ElMessage.warning('请输入4至16位长度的密码.')
      } else if(initData.pass1 !== initData.pass2) {
        ElMessage.warning('两次密码不一致.')
      } else { // password
        let data = {
          id: initData.userInfo.id,
          oldPassword: initData.pass0,
          newPassword: initData.pass1,
          type: 1
        }
        initData.postLoading = true
        api("post", "password", data)
          .then(res => {
            initData.postLoading = false
            if(res.code === 1200) {
              ElNotification({
                title: 'Success',
                message: '修改成功',
                type: 'success',
              })
              loginOut()
            } else {
              ElNotification({
                title: '提示',
                message: res.msg,
                type: 'error',
              })
            }
          })
          .catch(err => {
            initData.postLoading = false
            ElNotification({
              title: '提示',
              message: '修改失败！请重新尝试.',
              type: 'error',
            })
          })
      }
    }
    // 退出登录
    function loginOut() {
      initData.userInfo = "";
      localStorage.removeItem("whgUserInfo");
      store.commit("clearUserInfo");
    }
    return {
      ...toRefs(initData),
      handlebtn,
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  width: 500px;
  align-items: center;
  .name {
    width: 80px;
    color: #585858;
  }
}
.regTel {
  width: 200px;
  margin-left: 80px;
}
</style>